// extracted by mini-css-extract-plugin
export default {"signUpContainer":"signUp_signUpContainer__aF-ly"};